{
  "checkedInTitle": "您已完成签到",
  "postCheckInInstructions": "签到后须知",
  "appointmentDetails": "预约详情",
  "notifyWarehouse": "我们已通知仓库您已到达，以便他们确认可用情况",
  "waitForStaff": "请等待仓库工作人员的进一步指示",
  "unplannedDescription": "您似乎没有预约。请等待仓库工作人员的进一步指示。",
  "whatsappDelay": "第一条 WhatsApp 消息最长可能需要一分钟才能送达。",
  "bookNextTitle": "预约下次到访",
  "bookNextBody": "注册 Opendock，以便您下次到访该仓库时可以提前预约",
  "helpFooter": "如需任何帮助或其他信息，请联系仓库工作人员",
  "finalize": "完成（{seconds}）"
}
